<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__sluserinvite}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.productName" placeholder="产品名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.realName" placeholder="经纪人" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select  v-model="dataForm.status" filterable clearable  placeholder="提现状态">
                  <el-option
                          v-for="item in shareProfit"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:sluserinvite:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:sluserinvite:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column prop="brokerName" label="经济人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="tenderId" label="进件编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalLoans" label="放款总额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalProfit" label="分润总额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="commission" label="提成" header-align="center" align="center"></el-table-column>
        <el-table-column prop="seniorClassAllowance" label="上级津贴" header-align="center" align="center"></el-table-column>
        <el-table-column prop="superiorAllowance" label="上上级津贴" header-align="center" align="center"></el-table-column>
        <el-table-column prop="settlementTime" label="结算时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" width="100" label="提现状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-select v-if="scope.row.myishsow" v-model="scope.row.status"  filterable clearable  placeholder="类型">
                  <el-option
                          v-for="item in shareProfit"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
            <div v-else>{{ geteducation(scope.row.status,'shareProfit') }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="updateBy" label="操作人" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('wx:shareProfit:ok')" type="text" size="small" @click="submitStatus(scope.row)">{{ scope.row.myishsow ? '完成' : '修改' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './shareProfit-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slprofitmanagement/page',
        getDataListIsPage: true,
        exportURL: '/sys/slprofitmanagement/export',
        deleteURL: '/sys/slprofitmanagement',
        deleteIsBatch: true
      },
      shareProfit: [],
      dataForm: {
        id: '',
        realName: '',
        productName: '',
        status: '',
        }
    }
  },
  created(){
    this.getshareProfitOptions()
  },
  methods:{
    //修改状态
    submitStatus(row){
      console.log(this.dataList.findIndex(item => item.id == row.id))
      let n = this.dataList.findIndex(item => item.id == row.id)
      this.$set(this.dataList,n,{...this.dataList[n],myishsow: !this.dataList[n].myishsow})
      if(row.myishsow){
        let obj = {
          id: row.id,
          status: row.status,
        }
        this.$http.put('/sys/slprofitmanagement/', obj ).then(({ data: res }) => {
          if (res.code !== 0) {
            this.query()
            return this.$message.error(res.msg)
          }
            this.$message.success(res.msg)
            this.query()
          }) 
      }
    },
    geteducation(v,name){
      if(name == 'userType')  return this.userTypes.filter(item => item.value == v)[0]?.label ;
      if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
      if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
      if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
      if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
      if(name == 'shareProfit') return this.shareProfit.filter(item => item.value == v)[0]?.label ;
    },
     //初始进件状态下拉框中的选项
     async getshareProfitOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=shareProfit`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.shareProfit = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.shareProfit.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
  },
  components: {
    AddOrUpdate
  }
}

</script>
